import { useEffect, useState } from "react";
import { getCsrfToken } from "../../services/authService";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "../../styles/AdminMessages.css";

export default function AdminMessages() {
  const { t } = useTranslation();
  const [messages, setMessages] = useState([]);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    loadMessages();
  }, []);

  const loadMessages = async () => {
    const response = await fetch("/api/admin/messages", {
      credentials: "include",
    });

    if (response.ok) {
      setMessages(await response.json());
    }
  };

  const markAsRead = async (id) => {
    const csrf = await getCsrfToken();

    const response = await fetch(`/api/admin/messages/${id}/read`, {
      method: "PATCH",
      credentials: "include",
      headers: {
        [csrf.headerName]: csrf.token,
      },
    });

    if (response.ok) {
      const updated = await response.json();

      setMessages((prev) =>
        prev.map((message) =>
          message.id === updated.id ? updated : message
        )
      );
    }
  };

  const filteredMessages = messages.filter((message) =>
    `${message.name} ${message.email} ${message.message}`
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  const deleteMessage = async (id) => {
    const csrf = await getCsrfToken();

    const response = await fetch(`/api/admin/messages/${id}`, {
      method: "DELETE",
      credentials: "include",
      headers: {
        [csrf.headerName]: csrf.token,
      },
    });

    if (response.ok) {
      setMessages((prev) => prev.filter((message) => message.id !== id));
    }
  };

  return (
    <main className="admin-page">
      <section className="admin-messages">
        <button
          className="admin-back-btn"
          onClick={() => navigate("/admin")}
        >
          ← {t("adminMessages.backToDashboard")}
        </button>
        <h1>{t("adminMessages.title")}</h1>

        <div className="admin-toolbar">
          <input
            type="text"
            placeholder={t("adminMessages.searchPlaceholder")}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className="messages-list">
          {filteredMessages.length === 0 ? (
            <div className="messages-empty">
              {t("adminMessages.empty")}
            </div>
          ) : (
            filteredMessages.map((message) => (
              <article
                key={message.id}
                className={`message-card ${message.readed ? "" : "unread"}`}
              >
                <div className="message-header">
                  <div>
                    <h2>{message.name}</h2>
                    <p>{message.email}</p>
                  </div>

                  <span className={message.readed ? "read-badge" : "unread-badge"}>
                    {message.readed ? t("adminMessages.read") : t("adminMessages.new")}
                  </span>
                </div>

                <p className="message-date">
                  {new Date(message.createdAt).toLocaleString()}
                </p>

                <p className="message-text">
                  {message.message}
                </p>

                {!message.readed && (
                  <button onClick={() => markAsRead(message.id)}>
                    {t("adminMessages.markAsRead")}
                  </button>
                )}

                <button
                  className="message-delete-btn"
                  onClick={() => deleteMessage(message.id)}
                >
                  {t("adminMessages.delete")}
                </button>
              </article>
            ))
          )}
        </div>
      </section>
    </main>
  );
}